import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function detectBrowser() {
  try {
    if (typeof navigator === 'undefined') {
      return 'unknown'
    }
    
    const userAgent = navigator.userAgent.toLowerCase()
    
    // Check for Brave browser using multiple methods
    if (isBraveBrowser()) {
      return 'brave'
    }
    
    // Check for other Chromium-based browsers first
    if (userAgent.includes('edg')) {
      return 'edge'
    } else if (userAgent.includes('opera') || userAgent.includes('opr')) {
      return 'opera'
    } else if (userAgent.includes('chrome')) {
      return 'chrome'
    } else if (userAgent.includes('firefox')) {
      return 'firefox'
    } else if (userAgent.includes('safari')) {
      return 'safari'
    }
    
    return 'unknown'
  } catch (error) {
    console.warn('Browser detection failed:', error)
    return 'unknown'
  }
}

function isBraveBrowser(): boolean {
  try {
    // Method 1: Check for Brave-specific API
    if (typeof (window as any).chrome !== 'undefined' && 
        typeof (window as any).chrome.brave !== 'undefined' && 
        typeof (window as any).chrome.brave.isBrave !== 'undefined') {
      return true
    }
    
    // Method 2: Check for navigator.brave
    if (typeof (navigator as any).brave !== 'undefined' && 
        typeof (navigator as any).brave.isBrave !== 'undefined') {
      return true
    }
    
    // Method 3: User agent detection for Brave
    const userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.includes('brave')) {
      return true
    }
    
    // Remove the unreliable webstore detection that causes false positives on Mac
    // The webstore API can be unavailable on Mac due to corporate policies
    // or security restrictions, causing Chrome to be misidentified as Brave
    
    return false
  } catch (error) {
    return false
  }
}

export function isChrome() {
  try {
    const browser = detectBrowser()
    
    // Primary check: Must be detected as Chrome
    if (browser !== 'chrome') {
      return false
    }
    
    // Secondary validation: Additional checks for Chrome-specific features
    // but don't rely on webstore API which can be blocked on Mac
    const userAgent = navigator.userAgent.toLowerCase()
    
    // Ensure it's actually Chrome and not another Chromium-based browser
    const isActualChrome = userAgent.includes('chrome') && 
                          !userAgent.includes('brave') &&
                          !userAgent.includes('edg') &&
                          !userAgent.includes('opera') &&
                          !userAgent.includes('opr')
    
    return isActualChrome
  } catch (error) {
    console.warn('Chrome detection failed:', error)
    return false
  }
}

export function getChromeDownloadUrl() {
  return 'https://www.google.com/chrome/'
}

export function redirectToChrome() {
  const currentUrl = window.location.href
  const chromeUrl = `googlechrome://${currentUrl.replace(/^https?:\/\//, '')}`
  
  window.location.href = chromeUrl
  
  setTimeout(() => {
    window.open(getChromeDownloadUrl(), '_blank')
  }, 1500)
}
